import { GraduationCap, Building2, Microscope, Award } from "lucide-react";

const milestones = [
  {
    icon: GraduationCap,
    title: "Formazione internazionale",
    text: "Specializzazione in RM addominale presso l'Addenbrooke's Hospital, University of Cambridge. Master 'Breast Imaging: Mammoguide' con il Dr. Wade Hedegard.",
  },
  {
    icon: Building2,
    title: "12 anni nel SSN",
    text: "Esperienza maturata all'Ospedale di Castelfranco Veneto (oggi sede dell'Istituto Oncologico Veneto) e in ASST Bergamo Est.",
  },
  {
    icon: Award,
    title: "Progetto Profumo · ATS Bergamo",
    text: "Membro della commissione per il follow-up delle donne affette da carcinoma mammario.",
  },
  {
    icon: Microscope,
    title: "AI in radiologia clinica",
    text: "Collaboro con aziende e sviluppatori nella validazione di strumenti di intelligenza artificiale per la diagnostica per immagini.",
  },
];

export default function About() {
  return (
    <section
      id="chi-sono"
      data-testid="about-section"
      className="py-24 lg:py-32 border-t border-stone-200 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <span className="eyebrow">Chi sono</span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-stone-900 leading-[1.1]">
              Un Medico Radiologo con un solido background clinico.
            </h2>
            <p className="mt-6 text-stone-600 leading-relaxed">
              Attualmente <strong className="text-stone-900 font-medium">Responsabile della Radiologia</strong> presso la Casa di Cura Palazzolo
              di Bergamo (struttura privata convenzionata), unisco esperienza ospedaliera, formazione internazionale e
              una particolare attenzione alla persona che si affida a me per un esame diagnostico.
            </p>
            <p className="mt-4 text-stone-600 leading-relaxed">
              Credo che la qualità di una diagnosi nasca dall'incontro tra rigore tecnico e ascolto.
              Per questo dedico tempo a comprendere la storia clinica di ogni paziente prima ancora di
              guardare le immagini.
            </p>

            <div className="mt-8 rounded-2xl border border-stone-200 p-6 bg-[#FAFAF9]">
              <p className="text-[11px] uppercase tracking-[0.22em] text-stone-500">In sintesi</p>
              <ul className="mt-3 space-y-2 text-sm text-stone-700">
                <li>· Laurea in Medicina e Chirurgia · 2007</li>
                <li>· Specializzazione in Radiodiagnostica · 2008 — 2012</li>
                <li>· Attività clinica continuativa dal 2012</li>
                <li>· Iscrizione Ordine dei Medici · Bergamo</li>
              </ul>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="overflow-hidden rounded-2xl border border-stone-200 aspect-[16/10] mb-8">
              <img
                data-testid="about-image"
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxoZWFsdGhjYXJlJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3Nzg0ODE5ODl8MA&ixlib=rb-4.1.0&q=85"
                alt="Refertazione radiologica"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="grid sm:grid-cols-2 gap-4">
              {milestones.map((m) => (
                <div
                  key={m.title}
                  data-testid={`about-milestone-${m.title.replace(/\s+/g, "-").toLowerCase()}`}
                  className="rounded-2xl border border-stone-200 bg-white p-6 hover:shadow-sm transition-shadow"
                >
                  <div className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-[#E9F0EE] text-[#3E615B]">
                    <m.icon size={18} />
                  </div>
                  <h3 className="mt-4 font-display text-lg font-medium text-stone-900">
                    {m.title}
                  </h3>
                  <p className="mt-2 text-sm text-stone-600 leading-relaxed">{m.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
